var map = {
	"./hz1.png": 38232,
	"./hz2.png": 14098,
	"./hz3.png": 48563,
	"./hz4.png": 82063,
	"./hz5.png": 72502,
	"./hz6.png": 95329,
	"./hz7.png": 61208,
	"./hz8.png": 38922,
	"./hz9.png": 86753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20425;